import { InjectionToken } from '@angular/core';

interface CommunityDetailsPageOptions {
    communityListPageUrl: string;
}

export const COMMUNITY_DETAILS_PAGE_OPTIONS = new InjectionToken<CommunityDetailsPageOptions>(
    'COMMUNITY_DETAILS_PAGE_OPTIONS'
);
